import React from "react"
import { Link } from "gatsby"
// import Layout from "../../components/layout"
// import SEO from "../../components/seo"
import {default as SeoComponent} from "../../components/seo"
import PostHeaderMeta from "../../components/event-header-meta"
import PostFooterMeta from "../../components/event-footer-meta"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
// import { toast } from 'react-toastify';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { navigate } from "gatsby";
import { window, document } from 'browser-monads';
// import SharePanel from "../../components/share"
import he from 'he';
// import moment from "moment/moment"
import { RegexUtils } from '../../utils/regexUtils'

const { localStorage } = window;

// var time_to_close=10000;
// var myTimer;
// var alertArticleDisplayed = false;
// var navigate_to_next_article = true;
// var toastId;
// var position;
var alertArticleDisplayed = false;
var start = false;
var middle = false;
var end = false;

// if (window.innerWidth>=500) {
//   position = toast.POSITION.TOP_RIGHT;
// } else {
//   position = toast.POSITION.BOTTOM_CENTER;

// }

if (localStorage ) {
  var count = localStorage.getItem(window.location.pathname+'_count');
  if (count) count++;
  else count = 1;
  localStorage.setItem(window.location.pathname+'_count', count);
}

if (localStorage && !start) {
  localStorage.setItem(window.location.pathname+'_start', Date.now());


  start=true;
}



/*toast.configure({
  autoClose: time_to_close,
  position: position,
  //draggable: false,
  //etc you get the idea
});*/

const SingleEvent = props => {
  const {
    pageContext: {
      id,
      postId,
      title,
      excerpt,
      content,
      uri,
      featuredImageTest,
      link,
      date,
      author,
      // categories,
      address,
      // tags,
      prev,
      next,
      // terms,
      duration,
      city,
      startDate,
      endDate,
      externalLink,
      province,
      // showMap,
      zip,
      vertical,
      kind
    },
  } = props

  var set_vertical_ok = false;


  var myInterval = setInterval(function() {
    if (typeof window !== 'undefined') {
      //console.log(props.pageContext.categories.nodes[0].name);
      if (window.document.getElementsByClassName('mag_header_vertical_mini_title') && window.document.getElementsByClassName('mag_header_vertical_mini_title')[0] && !set_vertical_ok) {
        //window.document.getElementsByClassName('mag_header_vertical_mini_title')[0].innerHTML = '<a href="/'+props.pageContext.categories.nodes[0].name.toLowerCase()+'"><h2 style="text-transform: capitalize">'+props.pageContext.categories.nodes[0].name+'</h2></a>';

        set_vertical_ok = true;
        clearInterval(myInterval);
      }
    }
  },100);


  window.addEventListener('scroll', function() {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight*0.45) {
      if (localStorage && !middle) {
        localStorage.setItem(window.location.pathname+'_middle', Date.now());
        middle=true;
      }
    }


    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight*0.9) {
      // you're at the bottom of the page
      if (localStorage && !end) {
        localStorage.setItem(window.location.pathname+'_end', Date.now());
        end=true;
      }


      console.log('alertArticleDisplayed: '+alertArticleDisplayed);

      /*if (next && !alertArticleDisplayed) {
        alertArticleDisplayed = true;
        console.log("90% Bottom of page");
        myTimer = setTimeout(function() {
          //console.log('End timer')
          if (navigate_to_next_article) {
            toast.dismiss(toastId);
            navigate(next.link.replace("https://new.startupitalia.eu/","").replace("http://new.startupitalia.eu/",""));
            console.log('navigate to next article 1 '+next.link.replace("https://new.startupitalia.eu/","").replace("http://new.startupitalia.eu/",""));
            //console.log('navigate to next article');
          }
          //navigate("/pippo");
        }, time_to_close-1000);


        console.log('fire notify next: '+alertArticleDisplayed);
        toastId = toast(<Msg />, {
        position: position,
        onOpen: ({ foo }) => console.log('toast onOpen'),
        onClose: ({ foo }) => function () {
          console.log('toast onClose');
          if (window.navigate_to_next_article) {
            toast.dismiss(toastId);
            navigate(next.link.replace("https://new.startupitalia.eu/","").replace("http://new.startupitalia.eu/",""));
            console.log('navigate to next article 2 '+next.link.replace("https://new.startupitalia.eu/","").replace("http://new.startupitalia.eu/",""));
          }
        }
      });
      }*/
      }
  });

  //console.log(`Location: ${window.location.href}`);
  //console.log(next);

  // function not_navigate() {
  //   clearTimeout(myTimer);
  //   navigate_to_next_article=false;
  //   console.log('Not navigate'+navigate_to_next_article);
  //   toast.dismiss(toastId);
  // }

  // const Msg = ({ closeToast, link }) => (
  //   <div className="newmag_popup">
  //     <p>PROSSIMO ARTICOLO</p><p>{next.title} </p>
  //     <button onClick={()=>navigate(next.link.replace("https://new.startupitalia.eu/","").replace("http://new.startupitalia.eu/",""))}>Leggi</button>
  //     <button onClick={()=>not_navigate()}>No grazie</button>
  //   </div>
  // )


  var content_ok = content.replace("<p","<p class=\"the-content-event\"").replace("<h3","<h4")
  if (featuredImageTest) {

    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest,"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    content_ok = content_ok.replace(featuredImageTest.replace(".png",""),"/img/white_pixel.png\" style=\"display:none\" replaced=\"");
    /*content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");
    content_ok = content_ok.replace(/-[0-9a-zA-Z]*\.png/,"");*/
  }

  content_ok = RegexUtils.clearUrlFromString(content_ok);

  var title_clean = he.decode(title);
  var excerpt_clean = he.decode(excerpt);
  //var title_clean = title;
  //var excerpt_clean = excerpt;

  return (
    <div className="newmag-single-article" vertical={vertical}>
      <SeoComponent
        title={title_clean + " #startupitalia "}
        description={excerpt_clean}
        meta={[
          {
            property: "og:image",
            content: featuredImageTest ? featuredImageTest : "",
          },
        ]}
      />
      <article
        data-id={id}
        id={`post-${id}`}
        className={`newmag-article post-${id} post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby entry`}
      >
        <PostHeaderMeta
          uri={uri}
          link={link}
          title={title_clean}
          date={date}
          author={author}
          excerpt={""}
          featuredImage={featuredImageTest}
          content={content}
          duration={duration}
          city={city !== "false" ? city : ""}
          startDate={startDate}
          endDate={endDate}
          address={address !== "false" ? address : ""}
          externalLink={externalLink}
          province={province !== "false" ? province : ""}
          zip={zip !== "false" ? zip : ""}
          vertical={vertical}
          postId={postId}
          kind={kind || 'EVENT'}
        />

        <div
          className="entry-content"
          dangerouslySetInnerHTML={{ __html: content_ok }}
        />
        {/* .entry-content */}

        <PostFooterMeta
          uri={uri}
          link={link}
          date={date}
          author={author}
          duration={duration}
          city={city}
          startDate={startDate}
          endDate={endDate}
          externalLink={externalLink}
          province={province}
          zip={zip}
        />
      </article>

      {/* #post-${ID} */}
      <nav
        className="navigation post-navigation"
        role="navigation"
        style={{ marginBottom: "120px" }}
      >
        <h2 className="screen-reader-text">Post navigation</h2>
        <div className="nav-links">
          {prev && (
            <div className="nav-previous">
              <Link
                duration={0.2}
                bg="white"
                direction="right"
                top="entry"
                to={`/${prev.link
                  .replace("https://new.startupitalia.eu/", "")
                  .replace("http://new.startupitalia.eu/", "")
                  .replace("http:/new.startupitalia.eu/", "")}`}
                rel="prev"
              >
                <span className="meta-nav" aria-hidden="true">
                  Evento precedente
                </span>
                <span className="screen-reader-text">Evento precedente:</span>{" "}
                <br />
                <span
                  className="post-title"
                  dangerouslySetInnerHTML={{ __html: he.decode(prev.title) }}
                  //dangerouslySetInnerHTML={{ __html: prev.title }}
                />
              </Link>
            </div>
          )}
          <br />
          {next && (
            <div className="nav-next" style={{ marginBottom: "40px" }}>
              <Link
                duration={0.2}
                bg="white"
                direction="right"
                top="entry"
                to={`/${next.link
                  .replace("https://new.startupitalia.eu/", "")
                  .replace("http://new.startupitalia.eu/", "")
                  .replace("http:/new.startupitalia.eu/", "")}`}
                rel="next"
              >
                <span className="meta-nav" aria-hidden="true">
                  Evento successivo
                </span>
                <span className="screen-reader-text">Evento successivo:</span>{" "}
                <br />
                <span
                  className="post-title"
                  //dangerouslySetInnerHTML={{ __html: next.title }}
                  dangerouslySetInnerHTML={{ __html: he.decode(next.title) }}
                />
              </Link>
            </div>
          )}
        </div>
      </nav>
    </div>
  )
}

export default SingleEvent
